export const API_EXTERNAL_ENDPOINT = 'escapadas'

export const API_INTERNAL_ENDPOINT = 'strapi/escapadas/list'
